import { Percent, AlarmClockOff } from "lucide-react";

import { PeriodoResumoAdminTarefas } from "@/types/tarefa.type";
import { Skeleton } from "@/components/ui/skeleton";
import { useTarefaAdminResumoPeriodo } from "@/hooks/use-tarefa-admin-resumo-periodo";
import { useTarefaAdminMaisAtrasadas } from "@/hooks/use-tarefa-admin-mais-atrasadas";

export function TarefaDesempenhoCard({ dias }: { dias: PeriodoResumoAdminTarefas }) {
  const { resumo, loading: loadingResumo } = useTarefaAdminResumoPeriodo(dias);
  const { tarefas: atrasadas, loading: loadingAtrasadas } = useTarefaAdminMaisAtrasadas(10, dias);

  const criadas = resumo.criadasPorDia.reduce((soma, row) => soma + row.total, 0);
  const concluidas = resumo.concluidasPorDia.reduce((soma, row) => soma + row.total, 0);
  const taxaConclusao = criadas > 0 ? Math.round((concluidas / criadas) * 100) : null;
  const maiorAtraso = atrasadas[0]?.atrasoDias;

  return (
    <div className="rounded-xl border border-border/60 bg-card p-4 shadow-sm">
      <p className="mb-3 text-sm font-semibold text-foreground">Desempenho</p>

      <div className="grid min-h-40 grid-cols-2 items-center gap-4">
        <div className="flex flex-col gap-2 rounded-lg border border-border/60 bg-muted/20 p-3">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-emerald-500/10 text-emerald-600 dark:text-emerald-400">
            <Percent className="h-4 w-4" />
          </span>
          <span className="text-xs font-medium text-muted-foreground">
            Concluídas ÷ criadas no período
          </span>
          {loadingResumo ? (
            <div className="h-7 w-14 animate-pulse rounded bg-muted" />
          ) : (
            <span className="font-mono text-2xl font-bold tabular-nums text-foreground">
              {taxaConclusao === null ? "—" : `${taxaConclusao}%`}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-2 rounded-lg border border-border/60 bg-muted/20 p-3">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-red-500/10 text-red-600 dark:text-red-400">
            <AlarmClockOff className="h-4 w-4" />
          </span>
          <span className="text-xs font-medium text-muted-foreground">
            Maior atraso em aberto, criada no período
          </span>
          {loadingAtrasadas ? (
            <div className="h-7 w-14 animate-pulse rounded bg-muted" />
          ) : (
            <span className="font-mono text-2xl font-bold tabular-nums text-foreground">
              {maiorAtraso === undefined ? "—" : `${maiorAtraso}d`}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
